import { useQuery } from '@tanstack/react-query';
import { PermissionAssignmentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionAssignmentsControllerGetAssignmentByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['permissionAssignmentsControllerGetAssignmentById', accessControlScope, args],
        queryFn: async () => {
            const api = new PermissionAssignmentsApi(accessControlConfig);
            return api.permissionAssignmentsControllerGetAssignmentById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionAssignmentsControllerGetAssignmentByIdQuery.js.map